import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Checkbox from '../Elements/Checkbox/Checkbox';
import Button from '../Elements/Button/Button';
import Input from '../Elements/Input/Input';
import { changeAddressInput, booleanChange, subscribeKlaviyo, productAlert } from '../../actions/checkout';
import { purifier } from '../../utils/dom';
import { translate } from '../../utils/locale';
import { baseName } from '../../utils/string';
import s from './Notification.scss';
import sN from '../Footer/Newsletter.scss';

const NotifyMe = ({ setup, footer, payment, cachedProduct, notifyMeState, toggleNotifyMe, ...props }) => {
	const notifyMeSize = cachedProduct?.sizes?.[0]?.id || '';
	const [notifyMeStatus, updateNotifyMeStatus] = useState(null);

	const notifyMeHandler = (e) => {
		e.preventDefault();
		toggleNotifyMe();
	};

	const onInputChange = (id, value) => {
		updateNotifyMeStatus(null);
		if (id === 'subscribeNotifyMe') props.booleanChange('newsletter');
		else if (id === 'emailNotifyMe') props.changeAddressInput('address', 'email', value);
	};

	const sendNotificationHandler = (e) => {
		e.preventDefault();

		if (payment.address.newsletter) props.subscribeKlaviyo(payment.address.email);
		props.productAlert({ email: payment.address.email, selected: baseName(notifyMeSize) })
			.then((result) => {
				if (!result.errors) {
					updateNotifyMeStatus('success');
					setTimeout(() => {
						toggleNotifyMe(false);
						setTimeout(() => {
							updateNotifyMeStatus(null);
						}, 1000);
					}, 4000);
				} else {
					updateNotifyMeStatus('error');
				}
				return result;
			}).catch((err) => console.log('DEBUG: product alert error', err));
	};

	return (
		<div className={[s.notification, s.notification__popup, s.notification__notifyMe].join(' ')}>
			<button className={[s.notification_screen, s[`notification_screen__${notifyMeState}`]].join(' ')} type="button" onClick={notifyMeHandler} aria-label="Close" />
			<div className={[s.notification_inner, s[`notification_inner__${notifyMeState}`]].join(' ')}>
				<div className={s.notification_inner_wrapper}>
					<div className={s.notification_inner_text}>
						<h3 className={s.notification_inner_text_title}>{ cachedProduct.name }<br />{ cachedProduct.variant }<br />{ cachedProduct.weight }</h3>
						<p>{ translate(setup, 'notifyMeInfo') }</p>
					</div>
					<div className={s.notification_inner_newsletter}>
						<div className={[sN.newsletter, sN.newsletter__popup].join(' ')}>
							<form className={[sN.newsletter_form, (notifyMeStatus === 'error' ? sN.newsletter_form__error : null)].join(' ')} onSubmit={sendNotificationHandler}>
								<Input id="emailNotifyMe" type="email" value={payment.address.email} placeholder={translate(setup, footer.newsletterInput)} inputChange={onInputChange} />
								<Checkbox variantClasses={['checkbox__mini']} id="subscribeNotifyMe" label={translate(setup, 'subscribeToNewsletter')} selected={payment.newsletter} inputChange={onInputChange} />
								<Button variantClasses={['button__newsletter']} type="submit" text={translate(setup, (notifyMeStatus === 'success' ? footer.newsletterThanks : 'notifyMeSend'))} />
							</form>
							<div className={sN.newsletter_termsWrapper}>
								<span className={sN.newsletter_terms} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, footer.newsletterTerms)) }} />
							</div>
						</div>
					</div>
					<Button type="a" location="#close" clickEventHandler={notifyMeHandler} variantClasses={['button__invisible']}>
						<span className={s.notification_inner_close}>
							<svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
								<line x1="0.108019" y1="0.894605" x2="10.5769" y2="11.3634" strokeWidth="0.5" />
								<line x1="10.5748" y1="1.10607" x2="0.105981" y2="11.5749" strokeWidth="0.5" />
							</svg>
						</span>
					</Button>
				</div>
			</div>
		</div>
	);
};

const mapState = ({ environment, checkout }, props) => ({
	setup: environment.setup,
	footer: environment.footer,
	payment: checkout.payment,
	...props,
});

export default hot(module)(connect(mapState, { changeAddressInput, booleanChange, subscribeKlaviyo, productAlert })(NotifyMe));
